import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import { Box, Typography, TextField, Collapse } from '@mui/material';
import { Iconify } from 'src/components';
import { noteToggleSx } from '../styles';
import SpeechToTextButton from './SpeechToTextButton';

const NoteToggle = ({
  value = '',
  onChange,
  placeholder = 'Add a note for this question...',
}) => {
  const [isOpen, setIsOpen] = useState(!!value);
  const hasNote = !!value?.trim();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLiveUpdate = useCallback((fullText) => {
    onChange?.(fullText);
    if (!isOpen) {
      setIsOpen(true);
    }
  }, [onChange, isOpen]);

  return (
    <Box>
      <Box
        onClick={handleToggle}
        sx={noteToggleSx(hasNote)}
      >
        <Iconify icon="mdi:note-edit-outline" width={18} height={18} />
        <Typography component="span">
          {hasNote ? 'View/Edit note' : 'Add a note'}
        </Typography>
      </Box>

      <Collapse in={isOpen}>
        <Box sx={{ mt: '12px' }}>
          <Box sx={{ position: 'relative' }}>
            <TextField
              multiline
              rows={2}
              placeholder={placeholder}
              value={value}
              onChange={(e) => onChange?.(e.target.value)}
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: 13,
                  '& fieldset': { borderColor: '#E0E0E0' },
                  '&:hover fieldset': { borderColor: '#BDBDBD' },
                  '&.Mui-focused fieldset': {
                    borderColor: '#00A76F',
                    boxShadow: '0 0 0 3px rgba(0,167,111,0.12)',
                  },
                },
                '& .MuiInputBase-input': {
                  paddingBottom: '28px',
                },
              }}
            />
            <Box sx={{ position: 'absolute', bottom: 6, right: 8 }}>
              <SpeechToTextButton
                currentValue={value || ''}
                onLiveUpdate={handleLiveUpdate}
              />
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: 11,
              color: '#919EAB',
              mt: '6px',
            }}
          >
            Notes are saved automatically
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

NoteToggle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default NoteToggle;
